import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: 'È adatto ai principianti?',
  answer: 'Assolutamente sì! Padel 360 parte dalle fondamenta (impugnatura, postura) per poi guidarti passo passo verso tecniche e tattiche più avanzate. È perfetto per chi vuole iniziare con il piede giusto ed evitare cattive abitudini.'
}, {
  question: 'Come riceverò il materiale?',
  answer: "L'accesso è immediato. Subito dopo l'acquisto, riceverai un'email con i link per scaricare il manuale principale in PDF e tutti i bonus (PDF ed Excel). Potrai leggerli su smartphone, tablet o computer."
}, {
  question: 'Ho già subito un infortunio, questo manuale mi aiuterà?',
  answer: 'Sì, i moduli 11 e 12 sono dedicati specificamente alle lesioni più comuni (gomito, polso, caviglia, ginocchio) con protocolli di rafforzamento e linee guida per il ritorno in campo in sicurezza.'
}, {
  question: 'I pagamenti sono sicuri?',
  answer: 'Il pagamento è processato tramite piattaforme sicure e crittografate. I tuoi dati sono protetti al 100%.'
}, {
  question: 'Posso stamparlo?',
  answer: 'Certamente. Tutti i file PDF sono formattati per essere facilmente stampabili se preferisci studiare su carta.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="w-full max-w-2xl mx-auto my-10" data-id="element-149">
      <h2 className="text-2xl font-black text-center text-gray-900 mb-6" data-id="element-150">
        Domande Frequenti
      </h2>
      <div className="space-y-3" data-id="element-151">
        {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg bg-white overflow-hidden" data-id="element-152">
            <button className="w-full px-5 py-4 text-left flex justify-between items-center font-bold text-gray-800 hover:bg-gray-50" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-153">
              <span className="pr-4" data-id="element-154">{faq.question}</span>
              {openIndex === index ? <ChevronUp className="w-5 h-5 text-blue-600 flex-shrink-0" data-id="element-155" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-156" />}
            </button>
            <AnimatePresence data-id="element-157">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.2
          }} data-id="element-158">
                  <div className="px-5 py-4 bg-gray-50 text-gray-600 border-t border-gray-100 leading-relaxed" data-id="element-159">
                    {faq.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </div>;
}